import { BLOCKS } from './constants';
export const useBlocks = () => {
  return BLOCKS;
};
